import { Router } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import EventBus from "services/eventBus";
import SecurityService from "services/securityService";
import { computed } from "mobx";
import NotificationService from "services/notificationService";
import OptionsService from "services/optionsService";
import BankExportRepository from "repositories/bankExportRepository";
import download from "downloadjs";
import BankExportListViewModel from "../bankExportListViewModel";
import CardReturnDetailViewModel from "./cardReturnDetailViewModel";
import { getBankExportFilename } from "../utils";
import parseFileNameFromAxiosResponse from "utils/parseFileNameFromAxiosResponse";
import type PayGateRefundExportResponse from "entities/payGateRefundExportResponse";

const navigationName = "card-returns";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [CardReturnDetailViewModel],
})
export default class CardReturnListViewModel extends BankExportListViewModel<PayGateRefundExportResponse> {
  @computed
  get name() {
    return this.translate("cardReturns");
  }

  constructor(
    protected detailViewModelFactory: ReturnType<typeof CardReturnDetailViewModel.Factory>,
    public repository: BankExportRepository,
    public securityService: SecurityService,
    public eventBus: EventBus,
    public localizationService: LocalizationService,
    public notificationService: NotificationService,
    public optionsService: OptionsService
  ) {
    super(repository, securityService, eventBus, localizationService, notificationService, optionsService);
    this.navigationName = navigationName;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.allCardReturns({ offset, limit }, this.appliedFilter);
  }

  async download(item: PayGateRefundExportResponse) {
    try {
      if (this.allowToDownload) {
        this.fileResponse = await this.repository.getCardReturnReport(item.id);
        download(
          this.fileResponse.data,
          parseFileNameFromAxiosResponse(this.fileResponse, getBankExportFilename(item)),
          "application/zip"
        );
      }
    } catch (exc) {}
  }
}
